export const assertPropsNotNull = (obj, props, callback = nullProps => {
  throw new Error("Props ".concat(nullProps.join(', '), " must not be null"));
}) => {
  const nullProps = [];

  for (const key of props) {
    if (obj[key] == null) {
      nullProps.push(key);
    }
  }

  if (nullProps.length > 0) {
    callback(nullProps);
  }
};
export const setDefaultProps = (obj, defaultProps) => {
  for (const key of Object.keys(defaultProps)) {
    if (obj[key] === null) {
      obj[key] = defaultProps[key];
    }
  }

  return obj;
};